export default {
  products: 'Productos',
  search: 'Buscar',
  accountArea: 'Área reservada',
  whyUs: 'Por qué nosotros',
  services: 'Servicios',
  company: 'Agencia',
  news: 'Noticias',
  resources: 'Recursos',
  contacts: 'Contactos',
  shop: 'Tienda',
  privacy: 'Política de privacidad',
  cookie: 'Política de cookies',
  copyright: 'Copyright',
  conditions: 'Condiciones de uso',
  language: 'Cambiar idioma',
  comeFarePer: 'Cómo hacer para',
}
